(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldSignerDetails', fbFieldSignerDetails);

    function fbFieldSignerDetails($timeout, lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                eventHandler: '&'
            },
            require: 'ngModel',
            templateUrl: 'common/libraries/formBuilder/fields/fieldSignerDetails',
            controller: fbFieldSignerDetailsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                ctrl.$render = function () {
                    vm.model = ctrl.$viewValue;
                }

                vm.commitChange = function (index, fieldName, fieldValue) {
                    // vm.model[index].edit[fieldName] = fieldValue;
                    ctrl.$setViewValue(vm.model);
                }
            }
        };
    }

    function fbFieldSignerDetailsCtrl(lodash, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            console.log('fbFieldSignerDetails', vm.element);

            vm.getLabel = function(col_name) {
                return lodash.get(vm.element, 'options.labels.' + col_name, '');
            }
        }
    }
})();